// Export as a module so we can mock using Jest. Mocking timers in Jest unfortunately conflicts with RTL's "waitFor" and
//  other async wait methods as they also use timers underneath, so we set this up to mock the time instead.
export default 300;
